import React from 'react';
import { SettingSlider } from '../../Sliders';
import { TEXT_SETTINGS_MORE } from '../constants';

import './settingsMore.scss'

interface SettingsMoreProps {
    rotate: number,
    spacing: number,
    size: number,
    onRotationChanged: (val: number) => void
    onSpacingChanged: (val: number) => void
    onSizeChanged: (val: number) => void
}

export const SettingsMore = (props: SettingsMoreProps) => {
    const { rotate, spacing, size, onRotationChanged, onSpacingChanged, onSizeChanged } = props

    return <div className='settings-more'>
        <SettingSlider {...TEXT_SETTINGS_MORE.rotate} value={rotate} onChange={onRotationChanged} />
        <SettingSlider {...TEXT_SETTINGS_MORE.arc} value={0} />
        <SettingSlider {...TEXT_SETTINGS_MORE.spacing} value={spacing} onChange={onSpacingChanged} />
        <SettingSlider {...TEXT_SETTINGS_MORE.size} value={size} onChange={onSizeChanged} />
    </div>
}